module.exports = __webpack_public_path__ + "static/media/visure-logo.084e4ef2.svg";